'use client'

import { useEffect, useState } from 'react'

export default function CustomCursor() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })
  const [cursorVariant, setCursorVariant] = useState('default')

  useEffect(() => {
    const mouseMove = (e: MouseEvent) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY
      })
    }

    window.addEventListener('mousemove', mouseMove)

    // 为不同元素设置不同的光标样式
    const handleMouseEnter = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      if (target.tagName === 'BUTTON' || target.tagName === 'A') {
        setCursorVariant('interactive')
      } else if (target.closest('.special-cursor')) {
        setCursorVariant('special')
      } else {
        setCursorVariant('default')
      }
    }

    document.addEventListener('mouseover', handleMouseEnter)

    return () => {
      window.removeEventListener('mousemove', mouseMove)
      document.removeEventListener('mouseover', handleMouseEnter)
    }
  }, [])

  const variants = {
    default: {
      height: 20,
      width: 20,
      backgroundColor: 'rgba(249, 115, 22, 0.2)',
      border: '2px solid rgba(249, 115, 22, 0.8)',
      mixBlendMode: 'difference' as const,
    },
    interactive: {
      height: 40,
      width: 40,
      backgroundColor: 'rgba(249, 115, 22, 0.3)',
      border: '2px solid rgba(249, 115, 22, 1)',
      mixBlendMode: 'difference' as const,
    },
    special: {
      height: 60,
      width: 60,
      backgroundColor: 'rgba(220, 38, 38, 0.3)',
      border: '3px solid rgba(220, 38, 38, 1)',
      mixBlendMode: 'difference' as const,
    }
  }

  return (
    <>
      {/* 自定义光标 */}
      <div
        className="fixed pointer-events-none z-50 rounded-full transition-all duration-200 ease-out"
        style={{
          left: `${mousePosition.x}px`,
          top: `${mousePosition.y}px`,
          transform: 'translate(-50%, -50%)',
          ...variants[cursorVariant as keyof typeof variants]
        }}
      />
      
      {/* 光标拖尾效果 */}
      <div
        className="fixed pointer-events-none z-40 rounded-full"
        style={{
          left: `${mousePosition.x}px`,
          top: `${mousePosition.y}px`,
          transform: 'translate(-50%, -50%)',
          height: '10px',
          width: '10px',
          backgroundColor: 'rgba(249, 115, 22, 0.6)',
          filter: 'blur(2px)',
          transition: 'all 0.1s ease-out'
        }}
      />
    </>
  )
}